import fileDownload from 'js-file-download'
import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Damaged, DamagedSummary, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from 'src/services/skuit/types'

export interface ExportProps {
  fields: string[],
  exportFilters?: ExportFilters,
}

export class DamagedAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Damaged>> => {
    const response = await this.api.get('/damages/damaged', config)
    return paginatedTransform(Damaged)(response.data)
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Damaged> => {
    const response = await this.api.get(`/damages/damaged/${guid}`, config)
    return rawTransform(Damaged)(response.data)
  }

  patch = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<Damaged> => {
    const response = await this.api.patch(`/damages/damaged/${guid}`, data, config)
    return rawTransform(Damaged)(response.data)
  }

  summary = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<DamagedSummary>> => {
    const response = await this.api.get('/damages/damaged/summary', config)
    return paginatedTransform(DamagedSummary)(response.data)
  }

  exportSummary = async ({ fields, exportFilters }: ExportProps) => {
    const params = { fields: fields.join(','), damaged_on_start: exportFilters?.start, damaged_on_end: exportFilters?.end }
    const response = await this.api.axiosInstance({
      url: '/damages/damaged/summary/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'damages.csv')
  }

  export = async ({ fields, exportFilters }: ExportProps) => {
    const params = { fields: fields.join(','), damaged_on_start: exportFilters?.start, damaged_on_end: exportFilters?.end }
    const response = await this.api.axiosInstance({
      url: '/damages/damaged/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'damages.csv')
  }
}
